import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import React, { useState } from "react"
import { FormattedMessage } from "react-intl"
import { ProductExportModal } from "../../../../product/components/ProductExportModal"
import { isError } from "../../../../state/helpers/Error"
import ListingHelper from "../../../../state/listing/ListingHelper"
import { ObjectType } from "../../../../state/listing/generic-listing"
import { SearchPayload } from "../../../../state/search/SearchPayload"
import EventBus from "../../../EventBus"
import Icon from "../../../icon/icon.component"
import GenericExportModal from "./GenericExportModal"

interface OwnProps {
    exportType: ObjectType
    filters: SearchPayload
}

const ProductExportModalWrapper = (props: OwnProps) => {
    const [show, setShow] = useState<boolean>(false)
    
    const handleStart = async () => {
        const res = await ListingHelper.batchExport(props.exportType, props.filters)

        if (!isError(res)) {
            EventBus.dispatch(EventBus.TopicSendSuccessNotification, {
                message: <FormattedMessage
                    id="generic-listing.export-modal.created-message"
                    defaultMessage="Export started successfully. A CSV export will be sent to {email}"
                    values={{
                        email: <strong>{AppContext.getUserLoggedIn().attributes.email}</strong>
                    }}
                />
            })
        }

        setShow(false)
    }

    if (AppContext.isInventoryEnabled()) {
        return (
            <>
                <button
                    onClick={() => setShow(true)}
                    className="btn btn-sm btn-secondary"
                >
                    <Icon value='file-export' className='mr-1' />
                    <FormattedMessage
                        id="generic-listing.export-all"
                        defaultMessage="Export all results"
                    />
                </button>

                {show && (
                    <ProductExportModal
                        onCloseCallback={() => setShow(false)}
                        email={AppContext.getUserLoggedIn().attributes.email}
                        filters={props.filters}
                        productExport={handleStart}
                        onExportStartedCallback={() => setShow(false)}
                    />
                )}
            </>
        )
    }

    return (
        <GenericExportModal
            exportType={props.exportType}
            filters={props.filters}
        />
    )
}

export default ProductExportModalWrapper


// WEBPACK FOOTER //
// ./src/common/listing/generic-listing/export-modals/ProductExportModal.tsx